module.exports = __webpack_public_path__ + "static/media/Incompleteicon.fc2dea39.svg";